<template>
  <div class="email-editor" :class="disabled && 'is-disabled'">
    <div v-show="emailInfoList.length > 0" class="email-list">
      <div
        v-for="(item, index) in emailInfoList"
        class="email-container"
        :key="item.id"
      >
        <div class="email-wrapper" :class="item.error && 'has-error'">
          <!-- <el-input v-model="item.value" maxlength="64" class="email-input" @blur="handelEmailInputBlur(item, index)"></el-input> -->
          <div class="email">{{ item.value }}</div>
          <div class="delete-btn" @click="handelEmailDeleteBtnClick(item, index)">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div v-if="item.error" class="error-message">{{ item.error }}</div>
      </div>
    </div>
    <div v-show="showNewEmail" class="new-email-container">
      <div class="new-email-wrapper" :class="newEmail.error && 'has-error'">
        <el-input v-model="newEmail.value" maxlength="64" class="new-email-input" @keypress.enter.native="handleAddBtnClick"></el-input>
        <el-button class="add-btn" type="text" @click="handleAddBtnClick">{{ $t(`${i18nPrefix}.btn.confirmAddEmail`) }}</el-button>
        <el-tooltip v-if="tipMessage" class="tip-message-icon" placement="top" :content="tipMessage">
          <span>
            <i class="el-icon-question"></i>
          </span>
        </el-tooltip>
      </div>
      <div v-if="newEmail.error" class="error-message">{{ newEmail.error }}</div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { emailRegexp } from '@/utils/validator'

export default {
  model: {
    prop: 'emailList',
    event: 'change'
  },
  props: {
    emailList: {
      type: Array
    },
    maxSize: {
      type: Number,
      default: -1
    },
    tipMessage: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.job.editor',
      infoVid: 0,
      emailInfoList: [],
      newEmail: {
        value: null,
        error: null
      }
    }
  },
  computed: {
    showNewEmail () {
      const emailList = this.emailList
      const maxSize = this.maxSize
      if (maxSize > -1 && emailList) {
        return maxSize > emailList.length
      }
      return true
    }
  },
  created () {

  },
  methods: {
    hasError () {
      return _.findIndex(this.emailInfoList, 'error') > -1
    },
    handleAddBtnClick () {
      this.newEmail.error = null
      const email = this.newEmail.value
      if (!email) {
        return
      }
      if (!emailRegexp.test(email)) {
        this.newEmail.error = this.$t(`${this.i18nPrefix}.message.invalidEmail`)
      } else if (this.emailList.includes(email)) {
        this.newEmail.error = this.$t(`${this.i18nPrefix}.message.emailIsExisted`)
      } else {
        this.newEmail.value = null
        this.emailList.push(email)
      }
    },
    handelEmailDeleteBtnClick (emailItem, itemIndex) {
      if (this.disabled) {
        return
      }
      this.emailList.splice(itemIndex, 1)
    },
    handelEmailInputBlur (emailItem, itemIndex) {
      emailItem.error = null
      const email = emailItem.value
      if (!email || !emailRegexp.test(email)) {
        emailItem.error = this.$t(`${this.i18nPrefix}.message.invalidEmail`)
      } else if (this.emailList.includes(email)) {
        emailItem.error = this.$t(`${this.i18nPrefix}.message.emailIsExisted`)
      } else {
        this.emailList[itemIndex] = email
      }
    }
  },
  watch: {
    emailList: {
      immediate: true,
      handler () {
        this.emailInfoList = _.map(this.emailList, email => {
          this.infoVid += 1
          return {
            id: this.infoVid,
            value: email,
            error: null
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.email-editor {
  .email-list {
    margin-bottom: 10px;
    padding: 0 10px;
    border: 1px solid #DCDFE6;

    .email-container {
      padding: 10px 0;

      &:not(:first-child) {
        border-top: 1px solid #DCDFE6;
      }

      .email-wrapper {
        display: flex;
        align-items: center;

        .email {
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .delete-btn {
          margin-left: 10px;
          font-size: 16px;
          cursor: pointer;
        }
      }
    }
  }

  .new-email-container {
    .new-email-wrapper {
      display: flex;
      align-items: center;

      .new-email-input {
        flex: 1;
      }

      .add-btn {
        padding: 8px 20px;
      }

      .tip-message-icon {
        font-size: 18px;
      }
    }
  }

  .error-message {
    font-size: 12px;
    color: #f56c6c;
  }

  &.is-disabled {
    .email-list {
      background-color: #f5f7fa;
      cursor: not-allowed;

      .email-container {
        .delete-btn {
          cursor: not-allowed;
        }
      }
    }
  }
}
</style>
